import { TinyMCEEvent } from './event.interface';
import { isTokenElement } from '../utils';
import { includes } from 'ramda';

const FONT_COMMANDS = ['FontName', 'FontSize', 'ForeColor'];

export const isFontSelectorEvent = (element: HTMLElement, event: TinyMCEEvent): boolean => {
  return isTokenElement(element) && includes(event.command, FONT_COMMANDS);
};
